<ng-container *ngIf="basketLocation">
  <div class="basketLocation-detail-impressum">
    <div class="basketLocation-detail-content-wrapper">
      <div class="list-header_icon">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-standort"></div>
        </div>
      </div>
      <ul>
        <h2 *ngIf="basketLocation?.label_de">{{basketLocation.label}}</h2>
        <li *ngIf="basketLocation?.address">
          <span>{{basketLocation.address}}</span>
        </li>
        <li *ngIf="basketLocation?.stnr">
          <span langkey="phInHouseLocalBasket_ImpressumDialog_stnr"></span>
          <span class="basketLocation-detail-text">{{basketLocation.stnr}}</span>
        </li>
        <li *ngIf="basketLocation?.ustid">
          <span langkey="phInHouseLocalBasket_ImpressumDialog_ustid"></span>
          <span class="basketLocation-detail-text">{{basketLocation.ustid}}</span>
        </li>
        <li *ngIf="impressumModelData?.impressumHtml && impressumModelData?.impressumHtml">
          <div a11y_Link (click)="openLocationImpressumDialog()" class="privacyLink">
            <span langkey="phInHouseLocalBasket_ImpressumDialog"></span>
          </div>
        </li>
      </ul>
      <ul>
        <li *ngIf="basketLocation?.commercial_register">
          <span langkey="phInHouseLocalBasket_ImpressumDialog_commercial_register"></span>
          <span class="basketLocation-detail-text">{{basketLocation.commercial_register}}</span>
        </li>
        <li *ngIf="basketLocation?.representative">
          <span langkey="phInHouseLocalBasket_ImpressumDialog_representative"></span>
          <span class="basketLocation-detail-text">{{basketLocation.representative}}</span>
        </li>
        <li *ngIf="basketLocation?.local_court">
          <span langkey="phInHouseLocalBasket_ImpressumDialog_local_court"></span>
          <span class="basketLocation-detail-text">{{basketLocation.local_court}}</span>
        </li>
      </ul>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="canDisplayOrderTimeSelection">
  <div class="serviceTime-container">
    <ng-container
      *ngIf="locationOpenDays && locationOpenDays.length > 0 && (serviceId === WebShopMode.Delivery || serviceId === WebShopMode.TakeAway)">
      <div class="abholzeit-select">
        <span>{{getServiceDayLabel()}}</span>
        <ya-select [items]="MapLocationOpenDaysToSelecet()"></ya-select>
      </div>
    </ng-container>
    <div class="abholzeit-select">
      <ng-container
        *ngIf="locationOpenDays && locationOpenDays.length > 0 && (serviceId === WebShopMode.Delivery || serviceId === WebShopMode.TakeAway)">
        <span>{{getServiceTimeLabel()}}</span>
      </ng-container>
      <div class="ya-input-container-flexwidth">
        <select a11y_Select class="ya-input-text requestServiceTime"
          (change)="setRequestServiceTimeOnChange($event.currentTarget.value)">
          <ng-container *ngFor="let serviceTime of serviceOpenTimeViewModels; let index = index">
            <option [value]="index"
              [selected]="selectedServiceTime == serviceTime.value && orderASAP == serviceTime.asap">
              {{serviceTime.display}}</option>
          </ng-container>
        </select>
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="canDisplaySelectedOrderTimeLabel()">
  <div class="serviceTime-info">
    <span class="service-label" [innerHTML]="loadOrderTimeLabel(selectedServiceTime)"></span>
  </div>
</ng-container>
<ng-container *ngIf="deliveryCountries && deliveryCountries.length > 0">
  <div class="deliveryCountries-title" langkey="phWebshop_PleaseChooseDeliveryCountry"></div>
  <div class="abholzeit-select">
    <div class="ya-input-container-flexwidth">
      <select a11y_Select class="ya-input-text requestServiceTime"
        (change)="selectDeliveryCountry(deliveryCountries[$event.currentTarget.value])">
        <option value="" disabled hidden [selected]="!selectedDeliveryCountry"
          langkey="phWebshop_PleaseChooseDeliveryCountry"></option>
        <ng-container *ngFor="let deliveryCountry of deliveryCountries; let index = index">
          <option [value]="index" [selected]="selectedDeliveryCountry && selectedDeliveryCountry == deliveryCountry">
            {{getDeliveryCountryName(deliveryCountry)}}</option>
        </ng-container>
      </select>
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
    </div>
  </div>
</ng-container>
<div class="content-container" [ngClass]="(table$ | async).no !==''?'': 'noTable' ">
  <ng-container *ngIf="table$ | async; let table;">
    <ng-container *ngIf="table.no !==''">
      <div class="user-container">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-single"></div>
        </div>
        <span *ngIf="table.name">{{table.name}}</span>
        <span *ngIf="!table.name" langkey="phInHouseLocalBasket_Guest_Label"></span>
        <span *ngIf="table.place" class="userPlace">{{SetUserPlace(table.place)}}</span>
      </div>
    </ng-container>
  </ng-container>
</div>
<div class="warenkorb">
  <div class="col">
    <!-- Basket items-->
    <div *ngIf="basketItems$ | async; let basketItems" class="ya-item-list-contaner">
      <ng-container *ngFor="let basketItem of basketItems; trackBy: trackBasketItemBy">
        <ya-basketItemCard [basketItem]="basketItem" [menucourses$]=" menucourses$"></ya-basketItemCard>
      </ng-container>
    </div>
  </div>
  <div class="col second">
    <ng-container *ngIf="useRedeemCoupon$ | async; let useCoupon">
      <div class="coupon_redeem">
        <div class="ya-button-container">
          <button a11y_Button class="coupon_btn--selection" (click)="navigateToCouponRedeem()">
            <span langkey="phCoupon_Redeem_Btn_Label"></span>
            <div class="inline-icon coupon-icon" inlineSVG="shop-icons.svg#ya-hypersoft-coupon"></div>
          </button>
        </div>
      </div>
    </ng-container>
    <ng-container>
      <div class="price-container">
        <span langkey="phWebshop_Shippingcart_SumOfProducts"></span>
        <span>{{formatCurrency(getBasketSumOfProducts())}}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="(serviceId === WebShopMode.Delivery || serviceId === WebShopMode.Retail) && !meetMinimomPrice">
      <div class="minimumDelivery-container">
        <span langkey="phWebshop_ShippingCart_MinimumDelivery"></span>
        <span class="bold">{{minimumDeliveryValue}}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="showFreeShippingNotice">
      <div class="minimumDelivery-container">
        <span>{{getFreeShippingText()}}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="hasOnlyBenefitItems(basketItems$ | async)">
      <div class="only-benefit-items-notice">
        <span langkey="phWebshop_Shippingcart_Only_Benefit"></span>
      </div>
    </ng-container>
    <ng-container *ngIf="canTip$ | async; let canTip">
      <div class="trinkgeld-container">
        <span langkey="phWebshop_Shippingcart_tip"></span>
        <div class="trinkgeld-slider-container">
          <mat-slider #tipSlider min="0" max="50" step="1" (change)="onSliderValueChange()"
            [(ngModel)]="trinkgeldSliderValue" thumbLabel [displayWith]="formatTipSliderLabel"></mat-slider>
        </div>
        <div class="trinkgeld-amount">
          <div class="ya-input-container">
            <input a11y_SpinButton numericInput inputmode="decimal" class="ya-input-text" (blur)="setWebView()"
              pattern="[0-9]*" (change)="onInputTrinkgeldChange($event)" onfocus="this.select()" onpaste="return false;"
              ondrop="return false" [(ngModel)]="trinkgeldInputValue">
          </div>
          <span>&nbsp;{{currencySymbol}}</span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="deliveryFee > 0">
      <div class="price-container deliveryFee">
        <span langkey="phWebshop_Shippingcart_DeliveryFee"></span>
        <span>{{formatCurrency(finalDeliveryFee)}}</span>
      </div>
    </ng-container>
    <div class="price-container total top-seperator">
      <span langkey="phWebshop_ShippingCart_Total"></span>
      <span>{{formatCurrency((canTip$ | async) ? getBasketSumTotal() : getBasketSumTotalWithoutTip())}}</span>
    </div>
    <!-- AGB Checkbox -->
    <div class="payment-options-container__option term-container"
      [class.term-space--customized]="newsletterCheckbox && newsletterCheckbox.isVisible">
      <div a11y_Checkbox class="input-checkbox-container">
        <mat-checkbox class="custom-ripple" [(ngModel)]="hasAcceptedAGB">
        </mat-checkbox>
      </div>
      <div #privacyContent (click)="onShowTermsClick($event)" class="payment-options-container__Text"
        [innerHtml]="AGB_innerhtml"></div>
    </div>
    <!-- Newsletter Checkbox -->
    <ya-newsletter-checkbox #newsletterCheckbox></ya-newsletter-checkbox>

    <ng-container *ngIf="canCheckIsSingleTab then singleTabContinue else defaultContinue"></ng-container>
    <ng-template #singleTabContinue>
      <div class="ya-webshop-button-container continue-button">
        <button a11y_Button mat-flat-button
          [disabled]="!(hasScheduledItems$|async)  && !hasOnlyBenefitItems(basketItems$ | async) && isShippingCartBtnActive(basketItems$ | async) ? null : true"
          (click)="continue()">
          <span>{{inHouseBtnLabel}}</span>
        </button>
      </div>
    </ng-template>
    <ng-template #defaultContinue>
      <div class="ya-webshop-button-container continue-button">
        <button a11y_Button mat-flat-button
          [disabled]="!(hasScheduledItems$|async)  && !hasOnlyBenefitItems(basketItems$ | async) && isShippingCartBtnActive(basketItems$ | async) ? null : true"
          (click)="continue()">
          <span langkey="phInHouse_Continue_Btn"></span>
        </button>
      </div>
    </ng-template>
    <ng-container *ngIf="showReturnToUrlBasketButton">
      <div class="ya-webshop-button-container continue-button">
        <button a11y_Button mat-flat-button (click)="navigateToUrlBasket()"><span
            langkey="phGlobal_Return"></span></button>
      </div>
    </ng-container>
  </div>
  <div class="recs">
    <ng-container *ngIf="recommendationProducts && recommendationProducts.length > 0">
      <div class="recommendation-product-title" langkey="phWebshop_Recommendation_Title"></div>
      <div id="recommended-product" class="item-column-container"
        [class.grid-customized]="recommendationProducts.length<=2">
        <ng-container *ngFor="let product of recommendationProducts">
          <div class="item-column-container__item">
            <ya-articlecard [product]="product" [isItemTagEnabled]="isItemTagEnabled" [itemTagType]="itemTagType"
              [options]="ArticleCardConfig">
            </ya-articlecard>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <!-- Table Overview -->
  <ng-container *ngIf="!mandatoryPayment">
    <ng-container *ngIf="tableSeats$ |async; let tableSeats">
      <ng-container *ngIf="tableSeats.length > 0">
        <div class="list-seperator"></div>
        <div class="Order-Container">
          <div class="order-header" (click)="isTableOverviewExpanded = !isTableOverviewExpanded"
            [ngClass]="{'active': isTableOverviewExpanded === true}">
            <ng-container *ngIf="table$ | async; let table;">
              <h3 langkey="phInHouseLocalBasket_Order_Overview"></h3>
            </ng-container>
            <div class="icon-container">
              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
            </div>
          </div>
          <div class="list-items-container">
            <ng-container *ngIf="isTableOverviewExpanded; then ListDetails else List"></ng-container>
            <ng-template #ListDetails>
              <ng-container *ngFor="let seat of tableSeats; let index = index; trackBy: trackTableSeatBy">
                <div class="display-list-detail">
                  <div class="user-container list-detail-header">
                    <div class="list-header_icon">
                      <div class="icon-container">
                        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-single"></div>
                      </div>
                    </div>
                    <ng-container *ngIf="table$ | async; let table;">
                      <div class="user-info">
                        <div class="user-info_name">
                          <ng-container
                            *ngIf="seat.isGuest && seat.nickname && seat.nickname.length > 0 then user else guest">
                          </ng-container>
                          <ng-template #user>
                            <h3>{{seat.nickname}}</h3>
                          </ng-template>
                          <ng-template #guest>
                            <h3 langkey="phInHouseLocalBasket_Guest_Label"></h3>
                          </ng-template>
                        </div>
                        <div class="user-info_place">
                          <h3 *ngIf="seat.seat" class="userPlace">{{SetUserPlace(seat.seat)}}</h3>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <div class="list-items_content">
                    <ng-container *ngFor="let item of seat.items; trackBy: trackTableSeatItemBy">
                      <div class="tag-wrapper">
                        <div class="info">
                          <div class="item">
                            <div class="orderItems-label-container">
                              <span>{{item.count >1? item.count + "x " + item.label: item.label}}</span>
                            </div>
                          </div>
                          <div class="seat-item-price">
                            <span class="order-price">{{formatCurrency(item.price * item.count)}}</span>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </ng-template>
            <!-- List View (Default)-->
            <ng-template #List>
              <ng-container *ngFor="let seat of tableSeats; let index = index; trackBy: trackTableSeatBy">
                <div class="list-content">
                  <div class="user-container list-detail-header">
                    <div class="list-header_icon list-icon">
                      <div class="icon-container">
                        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-single"></div>
                      </div>
                    </div>
                    <ng-container *ngIf="table$ | async; let table;">
                      <div class="user-info">
                        <div class="user-info_name">
                          <h3>{{seat.nickname}}</h3>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
              <div class="list-seperator"></div>
              <div class="table-order-total" *ngIf="table$ | async; let table">
                <span langkey="phInHouseLocalBasket_Order_List_total"></span>
                <span>{{formatCurrency(table.open_price)}}</span>
              </div>
            </ng-template>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>